import { render } from "./passwordVideo.vue?vue&type=template&id=64c0c271"
import script from "./passwordVideo.vue?vue&type=script&lang=js"
export * from "./passwordVideo.vue?vue&type=script&lang=js"

import "./passwordVideo.vue?vue&type=style&index=0&id=64c0c271&lang=css"

import exportComponent from "/Users/bob/Documents/GitHub/BreakOutTheBox/webappV2/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__